import { GalleryBrowseEnum } from 'common/module/gallery/browse.enum';
import { GalleryDraggingStatusEnum } from 'common/module/gallery/dragging-status.enum';
import { GalleryTemplatePropsInterface } from 'common/module/gallery/template-props.interface';

/**
 * Generates sliding styles for item in gallery
 *
 * @param index - position of the item in gallery
 */
export function galleryGetSlidingStyles(props: GalleryTemplatePropsInterface, index: number): string {
  // Is the item sliding ?
  const slidingIndex = props.slidingIndex.indexOf(index);

  // Dragging & item sliding
  if (props.draggingStatus === GalleryDraggingStatusEnum.active && slidingIndex > -1) {
    // Set position instantly with current drag value
    const pixels = props.pointerPosition.current - props.pointerPosition.start;
    const style = [
      'z-index: 2',
      'transition-duration: 0ms',
      'transform: translateX(calc(' + props.itemsPositions[index].positionX + '% + ' + pixels + 'px))',
    ];

    return style.join('; ');
  }

  // Sliding item
  if (slidingIndex > -1) {
    const style = [
      'z-index: 2',
      'transition-duration: 300ms',
      'transform: translateX(' + props.itemsPositions[index].positionX + '%)',
    ];

    // Not browsing or browsing toward next item or browsing toward previous item
    if (
      props.browse === GalleryBrowseEnum.none ||
      (props.browse === GalleryBrowseEnum.next && index === props.slidingIndex[2]) ||
      (props.browse === GalleryBrowseEnum.previous && index === props.slidingIndex[0])
    ) {
      // Set position instantly
      style.push('transition-duration: 0ms');
    }

    return style.join('; ');
  }

  // Default behavior
  return 'transform: translateX(' + props.itemsPositions[index].positionX + '%);';
}
